import * as React from 'react';
import { Tabber } from '../../../../designSystem/Tabber';
import { useNavigate } from 'react-router-dom';

type ArticlesTabProps =
    {
        selectedTab: 'articles' | 'subscribers' | 'configuration' | 'followup' | 'retsinfo';
    };
export function ArticlesTab (props: ArticlesTabProps): JSX.Element
{
    const navigate = useNavigate();

    function handleTabChange (tab: string)
    {
        if (tab === 'articles')
            navigate('/amorgy/articles');
        else if (tab === 'subscribers')
            navigate('/amorgy/articles/subscribers');
        else if (tab === 'configuration')
            navigate('/amorgy/articles/configuration');
        else if (tab === 'followup')
            navigate('/amorgy/articles/followup');
        else if (tab === 'retsinfo')
            navigate('/amorgy/articles/retsinfo');
        else
            throw new Error('Not implemented');
    }

    return (
        <Tabber                
            alignment='center'
            inline
            variant='text'
            onClick={handleTabChange}
            selectedTabName={props.selectedTab}
            items={[
                {
                    tabName: 'articles',
                    text: 'Lovkrav'
                },
                {
                    tabName: 'subscribers',
                    text: 'Abonnenter'
                },
                {
                    tabName: 'configuration',
                    text: 'Opsætning'
                },
                {
                    tabName: 'followup',
                    text: 'Opfølgning'
                },
                {
                    tabName: 'retsinfo',
                    text: 'Retsinformation'
                }
            ]}
        />
    );
}